import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { StatisticService } from '../../../../../services/statistic.service';


@Component({
  selector: 'app-dashboard-misc-nb-average-tracker-per-user',
  templateUrl: './nb-average-tracker-per-user.html'
})
export class NbAverageTrackerPerUserComponent implements OnInit, OnDestroy {
  statValue: number;
  subscription: Subscription;

  constructor(protected statisticService: StatisticService) {
  }

  ngOnInit(): any {
    this.subscription = this.statisticService.nbAverageTrackerPerUser().subscribe((result: number) => this.statValue = result)
  }

  ngOnDestroy(): any {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/dashboard/misc/nb-average-tracker-per-user/nb-average-tracker-per-user.component.ts